import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#FFF" fillRule="evenodd"><path d="M10 3a2 2 0 100 4 2 2 0 000-4M7 12.31a2.32 2.32 0 110-4.63 2.32 2.32 0 010 4.63M7 7a3 3 0 100 6 3 3 0 000-6" /><path d="M8 14.38A6.38 6.38 0 118 1.62a6.38 6.38 0 010 12.76M8 0a8 8 0 10.01 16.01A8 8 0 008 0" /></g></svg>;